import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { omit, path, propEq } from 'ramda';
import { TransitionGroup } from 'react-transition-group';
import { Route, Switch } from 'react-router';
import { renderWhenNotNil } from '../../shared/utils/rendering';
import { ROUTES } from '../routes';
import { AnimatedBooking } from '../booking/animatedBooking';
import { ExperienceHome } from './experienceHome';
import { PolicyOverlay } from '../../shared/components/policyOverlay';
import { Animated } from '../../shared/components/animated';

const slugFromProps = path(['match', 'params', 'experienceSlug']);

const parseRouteData = ({ match, ...routeProps }) => ({
  visible: propEq('isExact', true, match || {}),
  routeProps: {
    ...routeProps,
    match: match ? omit(['isExact'], match) : null,
  },
});

export class Experience extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired,
    experience: PropTypes.object,
    fetchExperience: PropTypes.func.isRequired,
    setCurrentExperienceBySlug: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const slug = slugFromProps(this.props);
    this.props.fetchExperience(slug);
  }

  componentDidUpdate(prevProps) {
    const slug = slugFromProps(this.props);
    if (slugFromProps(prevProps) !== slug) {
      this.props.fetchExperience(slug);
    }
  }

  componentWillUnmount() {
    this.props.setCurrentExperienceBySlug(null);
  }

  render() {
    const { experience, match } = this.props;

    return (
      <Fragment>
        <Switch>
          <TransitionGroup component={null}>
            {renderWhenNotNil(() => (
              <Route path={match.path + ROUTES.booking.base()}>
                {route => {
                  return <AnimatedBooking {...parseRouteData(route)} />;
                }}
              </Route>
            ))(experience)}

            <Route>
              {route => {
                const { visible, routeProps } = parseRouteData(route);
                return (
                  <Animated visible={visible}>
                    <ExperienceHome {...routeProps} />
                  </Animated>
                );
              }}
            </Route>
          </TransitionGroup>
        </Switch>
        <PolicyOverlay />
      </Fragment>
    );
  }
}
